import { useQuery } from '@tanstack/react-query';
import { validateCsv, listCsv } from 'services/self-serve-magic-link';

export const useValidateSSMagicLinkCSV = file => {
  return useQuery(
    ['validate-self-serve-magic-link', { file }],
    () => {
      const formData = new FormData();
      formData.append('file', file);
      return validateCsv(formData);
    },
    {
      staleTime: 0,
      cacheTime: 0,
      enabled: !!file,
      networkMode: 'always',
    },
  );
};

const CSV_INFO_REFRESH_INTERVAL = 1000 * 5; // 5 seconds
const CSV_INFO_REFRESH_INTERVAL_LONG = 1000 * 60 * 5; // 5mins

export const useListSSMagicLinkCsv = ({ page, limit }) => {
  return useQuery(
    ['uploadedSSMagicLinkCSV', { page, limit }],
    () => listCsv({ page, limit }),
    {
      refetchInterval: latestData => {
        if (latestData?.data?.some(v => v?.status === 'processing')) {
          return CSV_INFO_REFRESH_INTERVAL;
        }
        return CSV_INFO_REFRESH_INTERVAL_LONG;
      },
    },
  );
};
